import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import constant from "./constant.js";
import axios from "axios";
import moment from "moment";
import {Modal, Toast} from '@coreui/coreui';

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
axios.defaults.withCredentials = true;
axios.interceptors.request.use((request) => {
  store.dispatch('startApiLoading');
  return request;
});
axios.interceptors.response.use((response) => {
  store.dispatch('stopApiLoading');
  return response;
}, (error) => {
  store.dispatch('stopApiLoading');
  if ([401, 419].includes(error.response.status)) {
    if (store.state.originalRoute) {
      // 認証エラーを起こす前の相対URLをログイン後のリダイレクト先として指定する
      store.commit('setApiErrorHandleStatus', {status: true});
      router.push({name: 'Login', query: {redirect: store.state.originalRoute.fullPath}});
    } else if (store.state.account.is_guest) {
      store.commit('setApiErrorHandleStatus', {status: true});
      router.replace({name: 'ErrorUnauthenticated'});
    }

    return Promise.reject(error);
  } else if ([403, 404].includes(error.response.status)) {
    if (store.state && store.state.originalRoute) {
      // Check page merger request
      const fullPath = store.state.originalRoute.fullPath || '';
      if (((fullPath).startsWith('/merger-request/') || ('/registration/merger-request' === fullPath))
      && ['MergerRequestForm', 'MergerRequestRegister'].includes(store.state.originalRoute.name)) {
        return Promise.reject(error);
      }
    }
    // 一律404画面を表示する
    store.commit('setApiErrorHandleStatus', {status: true});
    router.replace({name: 'BrokerErrorNotFound'})
  } else {
    return Promise.reject(error);
  }
});

createApp(App)
  .use(router)
  .use(store)
  .provide('$constant', constant)
  .provide('$axios', axios)
  .provide('$moment', moment)
  .provide('$modal', Modal)
  .provide('$toast', Toast)
  .mount('#app');
